import React, { Component } from 'react'

import Modal from '../Modal/Modal'
import Form from '../Form/Form'

class EditBlockWords extends Component {

    state = {
        blockWords: this.props.blockWords.join('\n')
    }

    onSave = () => {
        this.props.onSave({
            blockWords: this.state.blockWords.split('\n').join(',')
        })
    }

    render() {
        const { blockWords = '' } = this.state

        return (
          <Modal
            narrow
            extraClassName="EditBlockWords"
            onCancel={this.props.onClose}
            onSave={this.onSave}
            saveText="Save"
            mode="edit"
            title="Block words">
            <Form>
                <div>
                    <textarea 
                        placeholder="Block words"
                        value={blockWords}
                        onChange={e => this.setState({ blockWords: e.target.value })} />
                </div>
            </Form>
          </Modal>
        )
    }
}

export default EditBlockWords



// WEBPACK FOOTER //
// ./src/components/LBUs/EditBlockWords.js